import { StyleSheet } from 'aphrodite';
import { destructive, errorLight } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	errorContainer: {
		border: `2px solid ${destructive}`,
		backgroundColor: errorLight,
	},
});
